import * as jose from 'jose';
import { useAuthCookie } from '~/composables/useAuthCookie';
import { COOKIE_NAME_OAUTH2_ID_TOKEN } from '~/types/cookieNames';
import { idTokenClaimsSchema, type IDTokenClaims } from '~/utils/auth/shared';

export const useAuth = () => {
    const cookie = useAuthCookie<string | null>(COOKIE_NAME_OAUTH2_ID_TOKEN);

    return computed<(IDTokenClaims & { userId: string }) | null>(() => {
        if (!cookie.value) return null;

        try {
            const decoded = jose.decodeJwt(cookie.value);

            const parsed = idTokenClaimsSchema.safeParse(decoded);
            if (!parsed.success) {
                console.error('[useAuth] ID Token schema validation failed', parsed.error);
                return null;
            }

            return {
                ...parsed.data,
                userId: parsed.data.sub
            };
        } catch (error) {
            console.error('[useAuth] Failed to decode ID Token', error);
            return null;
        }
    });
};
